import { render, staticRenderFns } from "./vLabelPreviewImage.vue?vue&type=template&id=2de27fb7&scoped=true"
import script from "./vLabelPreviewImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./vLabelPreviewImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vLabelPreviewImage.vue?vue&type=style&index=0&id=2de27fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de27fb7",
  null
  
)

export default component.exports